
import {
  Prop,
  Vue,
  Component
} from "@/shared/vuepack";

@Component({
})

export default class DocumentSignatureDynamicTemplate extends Vue {
  @Prop()
  templateHtml: string;

  @Prop()
  data;

  created () {
    this.$options.template = "<span>" + this.templateHtml + "</span>";
  }
}
